export const config = {
  dashboard: { show: true, childKeys: [] },
  profile: {
    show: true,
    childKeys: [
      'profile',
      'login',
      'register',
      'forgot-password',
      'reset-password',
      'register-confirmation',
      'autologin',
    ],
  },
  accounting: { show: true, childKeys: [] },
  sales: {
    show: true,
    childKeys: [
      'invoices-form',
      'invoices',
      'invoices-preview',
      'correction-invoices-preview',
      'proformas-preview',
      'proformas-form',
      'proformas',
      'corrections-forms',
    ],
  },
  costInvoices: {
    show: true,
    childKeys: [
      'cost-invoices',
      'cost-invoices-form',
      'cost-invoices-form-edit',
      'cost-invoices-form-preview',
      'cost-invoices',
    ],
  },
  contractors: { show: true, childKeys: [] },
  warehouse: { show: true, childKeys: ['products'] },
  settings: { show: true, childKeys: ['settings', 'settings-exports', 'linkedin-login'] },
  password: {
    minLength: 12,
    minLowercase: 1,
    minUppercase: 1,
    minNumbers: 1,
    minSymbols: 2,
    complexityHelperText: "Hasło powinno mieć co najmniej 12 znaków, wielkie i małe litery, cyfry oraz 2 znaki specjalne",
  },  
};
